import '@pohlcon/design-system/style.css';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import messages from '@intlify/unplugin-vue-i18n/messages';
import { configureI18n } from '@pohlcon/design-system';

import App from './App.vue';
import router from './router';

const app = createApp(App)
  .provide("window", window)
  .use(configureI18n({ projectLocales: messages, defaultLanguage: "de", fallbackLocale: "en" }))
  .use(createPinia())
  .use(router);
app.mount("#app");
